import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'
import cx from 'classnames'

import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'
import { useDisclosure } from '@cred/react-disclosures-sdk'

import Tooltip from 'components/tooltip'
import Link from 'components/link'
import { DEFAULT_ADVERTISER_DISCLOSURE } from 'common/constants'
import sanitizeHTMLContent from 'utils/sanitizeHTMLContent'
import withApolloProvider from 'components/hocs/withApolloProvider'

import styles from './styles.module.scss'

const RateWidgetFooter = (props) => {
  const {
    containerClass,
    noMargin = false,
    multiVertical = false,
    withAdvertiserDisclosure = true,
  } = props
  const smallerCls = multiVertical ? 'small' : ''
  const poweredByCls = multiVertical ? 'poweredBy' : ''
  const reverseCls = multiVertical ? 'reverse' : ''
  const { disclosure: { htmlContent: disclosureContent } = {} } =
    useDisclosure(DEFAULT_ADVERTISER_DISCLOSURE) || {}

  return (
    <div className={cx(styles.container, styles[reverseCls], containerClass)}>
      <div className={styles.links}>
        <p
          className={cx('disclaimer', {
            'mt-16': !multiVertical,
            'ml-md-16': !noMargin,
          })}
        >
          <Link
            type="disclaimer"
            color="accent"
            rel="nofollow"
            className={styles[smallerCls]}
            blank
            href={`${config.credibleRoot}/terms`}
          >
            Terms
          </Link>
          <span> | </span>
          <Link
            type="disclaimer"
            color="accent"
            rel="nofollow"
            className={styles[smallerCls]}
            blank
            href={`${config.credibleRoot}/privacy`}
          >
            Privacy Policy
          </Link>
          {withAdvertiserDisclosure && (
            <>
              <span> | </span>{' '}
              <Tooltip
                analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
                triggerClassName="disclaimer secondary500"
                contentClassName="disclaimer neutral500"
                triggerContent={<span className={styles[smallerCls]}>Advertiser Disclosure</span>}
              >
                <div className="disclaimer">
                  <div
                    dangerouslySetInnerHTML={{ __html: sanitizeHTMLContent(disclosureContent) }}
                  />
                </div>
              </Tooltip>
            </>
          )}
        </p>
      </div>
      <div className={styles.logo}>
        <p
          className={cx('disclaimer', styles[poweredByCls], {
            'mt-8 mt-md-16': !multiVertical,
          })}
        >
          Powered by{' '}
          <img alt="Credible logo" src={logo} className={`${noMargin ? '' : 'mr-md-16'}`} />
        </p>
      </div>
    </div>
  )
}

RateWidgetFooter.propTypes = {
  noMargin: PropTypes.bool,
  multiVertical: PropTypes.bool,
  containerClass: PropTypes.string,
  withAdvertiserDisclosure: PropTypes.bool,
}

export default withApolloProvider(RateWidgetFooter)
